import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';

const requests = ['requestsDrawingResultWinnersGet'];
export default function useIsPending() {
  return useRequestsHandlerData(
    requests.map((address) => ({
      address,
    })),
  );
}
